import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import './common/css/font-awesome.min.css';

import Adminprofile from './components/Account/Adminprofile';
import Login from './components/Account/Login';
import Logout from "./components/Account/Logout";
import Setting from "./components/Account/Setting";
import Changepassword from "./components/Account/Changepassword";
import Forgetpassword from "./components/Account/Forgetpassword";
import Resetpassword from "./components/Account/Resetpassword";
import Company from "./components/Company/List";
import CompanyAdd from "./components/Company/Add"
import CompanyEdit from "./components/Company/Edit";


import UserList from "./components/User/List";
import UserEdit from "./components/User/Edit";
import UserAdd from "./components/User/Add";
import UserView from "./components/User/View";

import VehicleList from "./components/Vehicle/List";
import VehicleEdit from "./components/Vehicle/Edit";
import VehicleAdd from "./components/Vehicle/Add";


import DriverAdd from "./components/Driver/Add";
import DriverList from "./components/Driver/List";
import DriverEdit from "./components/Driver/Edit";
import DriverView from "./components/Driver/View";



import Fontlist from "./components/Fonts/List";
import FontAdd from "./components/Fonts/Add";
import FontEdit from "./components/Fonts/Edit";

import TemplateList from './components/Templates/List';
import TemplateAdd from './components/Templates/Add';
import TemplateEdit from './components/Templates/Edit';

import DashboardList from "./components/Dashboard/List";
//import Gallery from "./components/Gallery/Gallery";



import AiFeedList from "./components/AiFeed/List";
import AiImport from "./components/AiFeed/Import";

import TabList from "./components/TabManagement/List";
import TabEdit from "./components/TabManagement/Edit";
import TabAdd from "./components/TabManagement/Add";
import CompanyClone from "./components/Company/CompanyClone";


import DashboardManagement from "./components/DashboardManagement/List";
import DashboardAdd from "./components/DashboardManagement/Add";
import DashboardEdit from "./components/DashboardManagement/Edit";
import './common/css/custom.css';

import SellingList from "./components/SellParking/List";
import SellingView from "./components/SellParking/View";


import BuyParkingList from "./components/BuyParking/List";
import  BuyParkingView from "./components/BuyParking/View";


import OngoingList from "./components/Ongoing/List";
import  OngoingView from "./components/Ongoing/View";

import CompletedslotsList from "./components/Completeslots/List";
import  CompletedslotsView from "./components/Completeslots/View";

import TransactionslotsList from "./components/Transaction/List";
import  TransactionslotsView from "./components/Transaction/View";



import AdvertisementCategoryList from "./components/AdvertisementCategory/List";
import AdvertisementCategoryEdit from "./components/AdvertisementCategory/Edit";
import AdvertisementCategoryAdd from "./components/AdvertisementCategory/Add";



import AdvertisementList from "./components/Advertisement/List";
import AdvertisementEdit from "./components/Advertisement/Edit";
import AdvertisementAdd from "./components/Advertisement/Add";


import CMSList from "./components/CMS/List";
import CMSEdit from "./components/CMS/Edit";
import CMSAdd from "./components/CMS/Add";
import CMSView from "./components/CMS/View";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route exact path="/profile" element={< Adminprofile />} />
      <Route path="/logout" element={< Logout />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/changepassword" element={<Changepassword />} />
      <Route path="/forget_password" component={Forgetpassword} />
      <Route path="/reset_password/:key" component={Resetpassword} />
      <Route path="/company" element={<Company />} />
      <Route path="/company-add" element={< CompanyAdd />} />
      <Route path="/company-edit/:ID" element={<CompanyEdit/>} />
      <Route path="/font-edit/:ID" element={<FontEdit />} />
      <Route path="/fonts" element={<Fontlist />} />
      <Route path="/font-add" element={<FontAdd />} />

      <Route path="/user" element={<UserList/>} />
      <Route path="/user-add" element={< UserAdd/>} />
      <Route path="/user-edit/:ID" element={<UserEdit/>} />
      <Route path="/user-view/:ID" element={<UserView/>} />

		   <Route path="/vehicle" element={<VehicleList/>} />
      <Route path="/vehicle-add" element={<VehicleAdd/>} />
      <Route path="/vehicle-edit/:ID" element={<VehicleEdit/>} />
     
		

      <Route path="/drivers" element={<DriverList/>} />
      <Route path="/drivers-add" element={<DriverAdd/>} />
      <Route path="/drivers-edit/:ID" element={<DriverEdit/>} />
      <Route path="/drivers-view/:ID" element={<DriverView/>} />

      {/*<Route path="/appointments" element={<AppointmentList/>} />
      <Route path="/appointment-view/:ID" element={<AppointmentView/>} />
      <Route path="/appointment-add" element={<AppointmentAdd/>} />
      <Route path="/appointment-assigned" element={<AppointmentAssigned/>} />
      <Route path="/appointment-observation" element={<AppointmentObservation/>} />
      <Route path="/appointment-assignedview/:ID" element={<AppointmentAssignedView/>} />
      <Route path="/appointment-observationview/:ID" element={<AppointmentObservationView/>} />

      
      <Route path="/membership" element={<MemList/>}  />
        <Route path="/membership-edit/:ID" element={<MemEdit/>} />
        <Route path="/membership-view/:ID" element={<MemView/>} />
        <Route path="/membership-add" element={<MemAdd/>} />

        <Route path="/membershipcategory" element={<MembershipCategoryList/>}  />
        <Route path="/membershipcategory-add" element={<MembershipCategoryAdd/>} />
        <Route path="/membershipcategory-edit/:ID" element={<MembershipCategoryEdit/>} />
       <Route path="/user" element={UserList} />
      <Route path="/edit/:ID" element={UserEdit} />
      <Route path="/view/:ID" element={UserView} />
      <Route path="/user-add" element={UserAdd} />
      <Route path="/user-import" element={UserImport} /> */}

      <Route path="/templates" element={<TemplateList />} />
      <Route path="/template/add" element={<TemplateAdd/>} />
      <Route path="/templates-edit/:ID" element={<TemplateEdit />} />
      <Route path="/dashboard" element={<DashboardList />} /> 
      <Route path="/company-clone/:ID" element={<CompanyClone />} />
    
            
      <Route path="/aifeed" element={<AiFeedList/>} />
     <Route path="/aifeed-import" element={<AiImport/>} />
      <Route path="/tabmanagement" element={<TabList/>} />
        <Route path="/tabmanagement-edit/:ID" element={<TabEdit/>} />
        
        <Route path="/tabmanagement-add" element={<TabAdd/>} />
        <Route path="/dashboardmanagement" element={<DashboardManagement/>} />
        <Route path="/dashboardmanagement/edit/:ID" element={<DashboardEdit/>} />       
        <Route path="/dashboardmanagement-add" element={<DashboardAdd/>} />


        <Route path="/advertisementcategory" element={<AdvertisementCategoryList/>} />
        <Route path="/advertisementcategory-edit/:ID" element={<AdvertisementCategoryEdit/>} /> 
        <Route path="/advertisementcategory-add" element={<AdvertisementCategoryAdd/>} />



        
        <Route path="/advertisement" element={<AdvertisementList/>} />
        <Route path="/advertisement-add" element={<AdvertisementAdd/>} />
        <Route path="/advertisement-edit/:ID" element={<AdvertisementEdit/>} />
        
    <Route path="/sellparking" element={<SellingList/>} />
    <Route path="/sellparking-view/:ID" element={<SellingView/>} />

    <Route path="/buyparking" element={<BuyParkingList/>} />
    <Route path="/buyparking-view/:ID" element={<BuyParkingView/>} />

      <Route path="/Ongoing" element={<OngoingList/>} />
      <Route path="/Ongoing-view/:ID" element={<OngoingView/>} />

      <Route path="/completedslots" element={<CompletedslotsList/>} />
      <Route path="/completedslots-view/:ID" element={<CompletedslotsView/>} />

      <Route path="/transaction" element={<TransactionslotsList/>} />
      <Route path="/transaction-view/:ID" element={<TransactionslotsView/>} />


        <Route path="/cms" element={<CMSList/>} />
        <Route path="/cms-edit/:ID" element={<CMSEdit/>} />
        <Route path="/cms-add" element={<CMSAdd/>} /> 

        <Route path="/cms-view/:ID" element={<CMSView/>} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
